import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export default function OnboardingTasks() {
  return (
    <Card className="bg-[rgb(252,252,252)] rounded-2xl">
      <CardContent className="p-0 m-0">
        <div className="flex items-center text-gray-600 px-4 pt-3 pb-2">
          <Sparkles className="w-4 h-4" />
          <div className="text-sm ml-1">Let the system learn more about you</div>
        </div>
        <hr className="mb-2" />
        <div className="flex flex-col divide-y">
          <Row title="What type of prescriptions do you fulfill?" subtitle="What are your pharmacy’s specialties?" action={<Button variant="outline" size="sm" className="h-8">Edit</Button>} />
          <Row title="Set up insurance billing" subtitle="Configure your insurance billing settings." action={<Button size="sm" className="h-8 bg-blue-700 text-white hover:bg-blue-700/90">View</Button>} optional />
          <Row title="Manage your storefront" subtitle="Add your pharmacy’s hours, services, and staff." action={<Button size="sm" className="h-8 bg-blue-700 text-white hover:bg-blue-700/90">Continue</Button>} />
        </div>
      </CardContent>
    </Card>
  );
}

function Row({ title, subtitle, action, optional }: { title: string; subtitle: string; action: React.ReactNode; optional?: boolean }) {
  return (
    <div className="flex items-center justify-between py-3 px-4">
      <div className="pr-4">
        {optional && <div className="text-xs text-muted-foreground mb-1">Optional</div>}
        <div className="text-lg font-semibold">{title}</div>
        <div className="text-sm text-muted-foreground">{subtitle}</div>
      </div>
      <div className="shrink-0">{action}</div>
    </div>
  );
}